<template lang="html">
  <svg xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" height="21.241" width="22" version="1.1" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" viewBox="0 0 21.999999 21.241">
   <g transform="translate(0 -1031.1)">
    <g transform="matrix(.37931 0 0 .37931 0 1030.7)">
     <path style="fill:#497ea8" d="m48 19.929v21.141c0 2.723-2.207 4.93-4.929 4.93h-21.071l-10 11v-11h-7.071c-2.722 0-4.929-2.207-4.929-4.929v-21.141c0-2.723 2.207-4.93 4.929-4.93h38.141c2.723 0 4.93 2.207 4.93 4.929z"/>
     <path style="fill:#33d883" d="m53.071 1h-38.142c-2.722 0-4.929 2.207-4.929 4.93v9.07h33.071c2.722 0 4.929 2.207 4.929 4.93v12.07h5.071c2.722 0 4.929-2.207 4.929-4.93v-21.14c0-2.723-2.207-4.93-4.929-4.93z"/>
     <circle cx="11" cy="31" r="3" style="fill:#fff"/>
     <circle cx="24" cy="31" r="3" style="fill:#fff"/>
     <circle cx="37" cy="31" r="3" style="fill:#fff"/>
    </g>
   </g>
  </svg>

</template>

<script>
export default {
  name: 'Message'
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/icons/Message.vue